import { render } from "./HeaderInfoCardPreview.vue?vue&type=template&id=09b3601f&scoped=true"
import script from "./HeaderInfoCardPreview.vue?vue&type=script&lang=js"
export * from "./HeaderInfoCardPreview.vue?vue&type=script&lang=js"

import "./HeaderInfoCardPreview.vue?vue&type=style&index=0&id=09b3601f&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b3601f"]])

export default __exports__